<template>
  <div>
    <a-form :form="form">
      <a-form-item label="图片" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <div class="clearfix" style="display: inline-block">
          <a-upload
            name="file"
            v-decorator="['picture', {rules: [{required: false, message: '请输入'}]}]"
            accept="image/png, image/jpeg, image/jpg"
            :action="actionUrl"
            list-type="picture-card"
            :file-list="fileList"
            :data="new_multipart_params"
            :before-upload="beforeUpload"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="fileList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                图片上传
              </div>
            </div>
          </a-upload>
          <span v-if="false">提示：图片宽高比为1:1</span>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </a-form-item>
      <a-form-item label="飞机识别号" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" />
      </a-form-item>
      <a-form-item label="出入状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-decorator="['status', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
          <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.monitor_plane_in_out_status">{{ val }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="出入时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-date-picker
          style="width:100%"
          v-decorator="['in_out_time', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
          format="YYYY-MM-DD HH:mm:ss"
          show-time
          placeholder="请选择时间"
          @ok="inOutTimeOK"
        />
      </a-form-item>
      <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" />
      </a-form-item>
      <a-form-item
        v-bind="buttonCol"
      >
        <a-row>
          <a-col span="6">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="10">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
          <a-col span="8"></a-col>
        </a-row>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { monitor_plane_in_out_update } from '@/api/monitor_plane'
import { oss_token_list } from '@/api/oss_token'
import moment from 'moment'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      actionUrl: '',
      previewVisible: false,
      previewImage: '',
      image: undefined,
      new_multipart_params: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      },
      fileList: [],
      form: this.$form.createForm(this),
      id: 0
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  created () {
    this.initOss()
  },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    moment,
    handleGoBack () {
      this.$emit('onGoBack')
    },
    inOutTimeOK (value) {
      console.log(value.format('YYYY-MM-DD HH:mm:ss'))
      this.form.setFieldsValue({
        in_out_time: value.format('YYYY-MM-DD HH:mm:ss')
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          monitor_plane_in_out_update(values, this.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
              }
              console.log(res, '修改成功')
            })
        }
      })
    },
    initOss () {
      oss_token_list().then(({ data }) => {
        console.log(data, '我是返回值')
        this.new_multipart_params.OSSAccessKeyId = data.accessid
        this.new_multipart_params.policy = data.policy
        this.new_multipart_params.signature = data.signature
        this.actionUrl = 'https://static2.jnzbtz.com'
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['id', 'picture', 'number', 'status', 'in_out_time', 'remark'])
        formData.status = formData.status + ''
        this.id = formData.id
        this.fileList = data.image
          ? [{
            url: data.image,
            uid: '1',
            name: 'xxx.png',
            status: 'done',
            response: 'Server Error 500'
          }]
          : []
        console.log('formData', formData)
        form.setFieldsValue(formData)
      })
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    beforeUpload (file) {
      const name = file.name
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      this.new_multipart_params.key = file.uid + '.' + suffix
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('你只能上传jpeg/png格式的图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('文件过大，请重新上传')
      }
      console.log('--------------------------------------', isJpgOrPng, isLt2M)
      return isJpgOrPng && isLt2M
    },
    // 进口图片
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj, () => {
        })
      }
      console.log('我要预览', file)
      this.previewImage = file.url || file.preview || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList, file }) {
      this.fileList = fileList
      if (file.status === 'removed') {
        this.form.setFieldsValue({ picture: '' })
        this.$message.error('请重新上传')
        this.image = undefined
      }
      if (file.status === 'done') {
        this.form.setFieldsValue({ picture: this.actionUrl + '/' + this.new_multipart_params.key })
        this.image = this.actionUrl + '/' + this.new_multipart_params.key
      }
    },
    handleCancel () {
      this.previewVisible = false
    }
  }
}
</script>
